import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProcesosWorkflowsModal, { type ProcesosWorkflowRow } from './ProcesosWorkflowsModal';
import {
  procesosWorkflowDetailPath,
  readProcesosReturnSearch,
  type ProcesosWorkflowLocationState,
} from './procesos-workflow-routes';

export default function ProcesosWorkflowModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as ProcesosWorkflowLocationState | null;
  const procesosReturnSearch = readProcesosReturnSearch(state);
  const returnPath = state?.returnPath || '/procesos';

  const handleClose = useCallback(() => {
    navigate(`${returnPath}${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleSelectWorkflow = useCallback((workflow: ProcesosWorkflowRow) => {
    navigate(procesosWorkflowDetailPath(workflow.id, procesosReturnSearch), {
      state: {
        workflowNombre: workflow.nombre,
        procesosSearch: procesosReturnSearch,
        returnPath,
      },
    });
  }, [navigate, procesosReturnSearch, returnPath]);

  return (
    <ProcesosWorkflowsModal
      open
      onClose={handleClose}
      onSelectWorkflow={handleSelectWorkflow}
    />
  );
}
